import {
  Activities,
  Card,
  DisplayText,
  ESpacings,
} from "@rentiohq/web-shared/dist/components";
import { getDocumentActivityFilter } from "utils/document.utils";
import { ts } from "../../../../../services";
import { ITabProps } from "../Document.types";

export const DocumentHistory = (props: ITabProps) => {
  const { document } = props;

  // Render
  const filter = getDocumentActivityFilter({ document });
  if (!filter) {
    return null;
  }

  return (
    <Card
      space={ESpacings.base}
      heading={
        <DisplayText size="extraSmall" space="tight">
          {ts.system("history")}
        </DisplayText>
      }
    >
      <Activities
        identifier={`document-${document.id}`}
        filter={filter}
        hasFetchMore={true}
        isCompact={true}
      />
    </Card>
  );
};
